import { render, staticRenderFns } from "./PostaCellChannels.vue?vue&type=template&id=01d379b3&scoped=true"
import script from "./PostaCellChannels.vue?vue&type=script&lang=js"
export * from "./PostaCellChannels.vue?vue&type=script&lang=js"
import style0 from "./PostaCellChannels.vue?vue&type=style&index=0&id=01d379b3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01d379b3",
  null
  
)

export default component.exports